import { render } from "./Footer.vue?vue&type=template&id=23a82038&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=23a82038&scoped=true&lang=scss"

import exportComponent from "/Users/gisselareyes/Documents/Github/gisse-la/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a82038"]])

export default __exports__